import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fRef } from '../../utils/React.js';
import { SpinnerPresentation } from '../Spinner/SpinnerPresentation.js';
import { mainClass } from './Label.styles.js';

var defaultProps = {
  onMouseHoverChange: function onMouseHoverChange() {
    /* empty */
  },
  onKeyboardFocusChange: function onKeyboardFocusChange() {
    /* empty */
  },
  type: "label"
};
var LabelPresentation = fRef(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;
  var disabled = props.disabled,
    loading = props.loading,
    id = props.id,
    ref = props.ref,
    children = props.children,
    htmlAttrs = props.htmlAttrs,
    className = props.className,
    expandToOverlay = props.expandToOverlay,
    htmlFor = props.htmlFor,
    onMouseHoverChange = props.onMouseHoverChange,
    onKeyboardFocusChange = props.onKeyboardFocusChange,
    isDisplayInline = props.isDisplayInline,
    type = props.type,
    value = props.value,
    _onChange = props.onChange,
    name = props.name,
    htmlInputAttrs = props.htmlInputAttrs,
    nonInteractive = props.nonInteractive;
  return /*#__PURE__*/React.createElement(React.Fragment, null, type !== "label" && !nonInteractive && /*#__PURE__*/React.createElement("input", Object.assign({
    id: htmlFor,
    className: "".concat(mainClass, "-input"),
    type: type,
    checked: value,
    onChange: function onChange(e) {
      return _onChange(e.target.checked, name, e);
    },
    onMouseEnter: function onMouseEnter() {
      if (document.documentElement.getAttribute("data-whatintent") === "mouse") {
        onMouseHoverChange(true);
      }
    },
    onMouseLeave: function onMouseLeave() {
      return onMouseHoverChange(false);
    },
    onFocus: function onFocus() {
      if (document.documentElement.getAttribute("data-whatinput") === "keyboard") {
        onKeyboardFocusChange(true);
      }
    },
    onBlur: function onBlur() {
      return onKeyboardFocusChange(false);
    }
  }, htmlInputAttrs)), nonInteractive ? /*#__PURE__*/React.createElement("span", Object.assign({}, htmlAttrs, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(mainClass), true), _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__disabled"), true), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__loading"), loading), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__overlay"), expandToOverlay), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__inline"), isDisplayInline), _cleanupClassObject)),
    id: id,
    ref: ref,
    onMouseEnter: function onMouseEnter() {
      if (document.documentElement.getAttribute("data-whatintent") === "mouse") {
        onMouseHoverChange(true);
      }
    },
    onMouseLeave: function onMouseLeave() {
      return onMouseHoverChange(false);
    },
    onFocus: function onFocus() {
      if (document.documentElement.getAttribute("data-whatinput") === "keyboard") {
        onKeyboardFocusChange(true);
      }
    },
    onBlur: function onBlur() {
      return onKeyboardFocusChange(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(mainClass, "-inner")
  }, children), loading && /*#__PURE__*/React.createElement("span", {
    className: "".concat(mainClass, "-spinner")
  }, /*#__PURE__*/React.createElement(SpinnerPresentation, {
    variant: "indeterminate",
    size: 24
  }))) : /*#__PURE__*/React.createElement("label", Object.assign({}, htmlAttrs, {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(mainClass), true), _defineProperty(_cleanupClassObject2, className, !!className), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__disabled"), disabled), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__loading"), loading), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__overlay"), expandToOverlay), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__inline"), isDisplayInline), _cleanupClassObject2)),
    id: id,
    htmlFor: htmlFor,
    ref: ref,
    onMouseEnter: function onMouseEnter() {
      if (document.documentElement.getAttribute("data-whatintent") === "mouse") {
        onMouseHoverChange(true);
      }
    },
    onMouseLeave: function onMouseLeave() {
      return onMouseHoverChange(false);
    },
    onFocus: function onFocus() {
      if (document.documentElement.getAttribute("data-whatinput") === "keyboard") {
        onKeyboardFocusChange(true);
      }
    },
    onBlur: function onBlur() {
      return onKeyboardFocusChange(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(mainClass, "-inner")
  }, children), loading && /*#__PURE__*/React.createElement("span", {
    className: "".concat(mainClass, "-spinner")
  }, /*#__PURE__*/React.createElement(SpinnerPresentation, {
    variant: "indeterminate",
    size: 24
  }))));
}, defaultProps);
LabelPresentation.displayName = "LabelPresentation";

export { LabelPresentation, defaultProps };
